import {
    AutocompleteInput,
    DateInput,
    NumberInput,
    ReferenceInput,
    required,
} from 'react-admin';
import { SimpleForm } from '@components/SimpleForm';
import { format } from '@helpers/numeric.ext';
import { Grid } from '@mui/material';

export const TargetForm = () => {
    return (
        <SimpleForm>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <DateInput source="effDateFrom" validate={[required()]} />
                </Grid>
                <Grid item xs={12} md={6}>
                    <DateInput source="effDateTo" validate={[required()]} />
                </Grid>
                <Grid item xs={12} md={6}>
                    <ReferenceInput source="storeId" reference="store">
                        <AutocompleteInput
                            optionText="name"
                            validate={[required()]}
                        />
                    </ReferenceInput>
                </Grid>
                <Grid item xs={12} md={6}>
                    <NumberInput source="target" format={format} />
                </Grid>
            </Grid>
        </SimpleForm>
    );
};
